<template>
    <div class="all">
        <div class="warp mt20">
            <div class="warp-header">
                <h2>系统设置</h2>
            </div>
            <div class="warp-body clearfix">
                <!-- 建方案 -->
                <div class="form-warp input-list field">
                    <div class="item clearfix" v-if="timeFieldSwitch === 1">
                        <span class="name fl">时间设置:</span>
                        <div class="input-father no-hidden">
                            <drowDowns v-model="saveData.searchTimeField">
                                <options v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.value"></options>
                            </drowDowns>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">复制设置:</span>
                        <div class="input-father">
                            <div class="checkbox-groups">
                                <label class="checkbox-box clearfix" v-for="(item,index) in copyFields" :key="index">
                                    <label class="checkbox-warp fl"><input name="" type="checkbox" v-model="saveData.copyFields" :value="item.field" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                    {{item.name}}
                            </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-btn">
                        <button class="btn save btn-jbblue" @click="submitData();">提交</button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data() {
        return {
            typeList:[
                {name:'发布时间',value:'news_posttime'},
                {name:'入库时间',value:'solr_create_time'}
            ],
            index:0,
            saveData:{
                searchTimeField:'',
                copyFields:[]
            },
            copyFields:[],//一件复制选项列表
            timeFieldSwitch:0//控制时间设置显示
        }
    },
    mounted() {
        let that = this;
        that.getSetShowList();
    },
    created() {
		
    },
    methods: {
        // 获取设置显示
        getSetShowList (){
            let that = this;
            that.$api.get('user/system-set/list',null,r =>{
                that.$utils.returnCode(r,function(){
                    that.timeFieldSwitch = r.data.timeFieldSwitch;
                    that.copyFields = r.data.copyFields;
                    that.saveData.copyFields = r.data.checkedCopyFields;
                    that.saveData.searchTimeField = r.data.timeField;
                    that.index = that.typeList.findIndex(item => item.value === r.data.timeField);
                })
            })
        },
        // 获取时间类型
        getTimeType () {
            let that = this;
            that.$api.get('user/index/search-time-field',null,r =>{
                that.$utils.returnCode(r,function(){
                    
                })
            })
        },
        // 选择时间类型
        selectType (index){
            this.index = index;
            this.saveData.searchTimeField = this.typeList[index].value;
        },
        // 保存
        submitData (){
            let that = this;
            that.$api.post('user/system-set/save',{data:this.saveData},r =>{
               that.$utils.returnCode(r,function(){
                    that.$utils.alertText('保存成功！');
                    setTimeout(()=>{
                        window.location.reload();
                    },1000)
               })
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/systemSettings.vue